export default __webpack_public_path__ + "static/media/palodent360.7382d0a3.png";